module.exports = __webpack_public_path__ + "static/media/bm-logo.604a65f6.png";